import React, { useState, useEffect } from "react"
import Drawer from "./Drawer/Drawer"
import calendarIcon from "../../../assets/icons/calendar.svg"
import styles from "./DateRangePicker.scss"

interface IProps {
  setStartDate: (date: Date) => void
  setEndDate: (date: Date) => void
  startDate: Date
  endDate: Date
}

const DateRangePicker = ({
  setStartDate,
  setEndDate,
  startDate,
  endDate
}: IProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  function onInputFocus() {
    setIsOpen(true)
  }

  function closeDrawer() {
    setIsOpen(false)
  }

  function onInputBlur(e) {
    if (
      e &&
      e.target &&
      e.target.id !== "dateInput" &&
      e.target.id !== "dateInputContainer" &&
      e.target.id !== "drawer" &&
      e.target.className !== "disabled" &&
      e.target.className !== "invisible" &&
      e.target.className !== "between" &&
      e.target.className !== "selected" &&
      e.target.className !== "default" &&
      e.target.id !== "drawer" &&
      e.target.id !== "monthSelector" &&
      e.target.id !== "monthSelectorButton" &&
      e.target.id !== "monthSelectorSpan" &&
      e.target.id !== "month" &&
      e.target.id !== "dayHeaderRow" &&
      e.target.id !== "dayName"
    ) {
      closeDrawer()
    }
  }

  useEffect(() => {
    window.addEventListener("click", onInputBlur)
    return () => window.removeEventListener("click", onInputBlur)
  }, [])
  return (
    <div id="dateInputContainer" className={styles.container}>
      <div>
        <span>
          <img src={calendarIcon} alt="startDate" />
          <div id="dateInput" onClick={onInputFocus}>
            {startDate ? startDate.format("DD/MM/YYYY") : "Du"}
          </div>
        </span>
        <span>-</span>
        <span>
          <img src={calendarIcon} alt="endDate" />
          <div id="dateInput" onClick={onInputFocus}>
            {endDate ? endDate.format("DD/MM/YYYY") : "Au"}
          </div>
        </span>
      </div>
      {isOpen && (
        <Drawer
          closeDrawer={closeDrawer}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      )}
    </div>
  )
}

export default DateRangePicker
